<template>
    <div>
        <div class="popup__header popup__header--no-bottom">
            <span class="title title--sl popup__title popup__title--keep" v-html="form.title"></span>
            <span class="popup__header-description" v-html="description"></span>
        </div>
        <div class="popup__content">
            <form class="form" @submit.prevent="submit">
                <div class="form__item form__item--medium-margin">
                    <span class="form__label form__label--hidden">{{ $lang('feedback.name') }}</span>
                    <el-popover v-model="errors.name.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.name.message">
                        <el-input slot="reference"
                                  class="input input--big"
                                  :class="{ 'add__error': errors.name.isErrorPaint }"
                                  :placeholder="$lang('feedback.name.placeholder')"
                                  v-model="form.name"
                                  required
                                  dusk="name"
                                  @focus="clearErrors"></el-input>
                    </el-popover>
                </div>
                <div class="form__item form__item--medium-margin">
                    <span class="form__label form__label--hidden">{{ $lang('feedback.phone') }}</span>
                    <el-popover v-model="errors.phone.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.phone.message">
                        <div slot="reference">
                            <input-phone-by-country v-if="phoneByCountry"
                                                    v-model="form.phone"
                                                    @focus="clearErrors"
                                                    :placeholder="$lang('feedback.phone.placeholder')"
                                                    required/>
                            <input-phone v-else
                                         class="input input--big"
                                         :class="{ 'add__error': errors.phone.isErrorPaint }"
                                         @focus="clearErrors"
                                         :placeholder="$lang('feedback.phone.placeholder')"
                                         v-model="form.phone"
                                         required/>
                        </div>
                    </el-popover>
                </div>
                <div class="form__item form__item--medium-margin">
                    <span class="form__label form__label--hidden">{{ $lang('feedback.email') }}</span>
                    <el-popover v-model="errors.email.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.email.message">
                        <el-input slot="reference"
                                  class="input input--big"
                                  :class="{ 'add__error': errors.email.isErrorPaint }"
                                  type="email"
                                  @focus="clearErrors"
                                  :placeholder="$lang('feedback.email.placeholder')"
                                  v-model="form.email"
                                  dusk="email"
                                  required/>
                    </el-popover>
                </div>
                <template v-if="showComment">
                    <div class="form__item form__item--medium-margin">
                        <span class="form__label form__label--hidden">{{ $lang('feedback.comment') }}</span>
                        <el-input dusk="comment"
                                  :rows="2"
                                  type="textarea"
                                  :placeholder="$lang('feedback.comment.placeholder')"
                                  v-model="form.comment"
                                  required/>
                    </div>
                </template>
                <div class="form__item form__item--medium-margin">
                    <el-popover v-model="errors.checked.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.checked.message">
                        <el-checkbox slot="reference"
                                     @change="clearErrors"
                                     :class="{ 'add__error': errors.checked.isErrorPaint }"
                                     v-model="form.checked"
                                     required>{{ $lang('feedback.policy.part1') }} <a class="el-checkbox__link" target="_blank" href="/assets/front/pdf/memorycode_processing_of_personal_data.pdf">{{ $lang('feedback.policy.part2') }}</a></el-checkbox>
                    </el-popover>
                </div>
                <div class="form__item">
                    <button dusk="submit-application" class="btn btn--middle btn--main-bg">{{ button }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {mask} from "vue-the-mask";
import {mapState} from "vuex";
import mixin from "../mixins/errors";
import helper from "../mixins/helper";
import InputPhone from "../components/InputPhone";
import InputPhoneByCountry from "../components/InputPhoneByCountry";
import Vue from "vue";
import {Lang} from "../utils/lang";
Vue.use(Lang);

const forEach = require('lodash/forEach');

export default {
    name: "FeedbackForm",
    mixins: [mixin, helper],
    directives: {mask},
    components: {InputPhone, InputPhoneByCountry},
    props: {
        title: {
            type: String,
            default: Vue.prototype.$lang('feedback.title')
        },
        description: {
            type: String,
            default: Vue.prototype.$lang('feedback.description')
        },
        button: {
            type: String,
            default: Vue.prototype.$lang('feedback.button.send')
        },
        showComment: {
            type: Boolean,
            default: true
        },
        phoneByCountry: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        form: {
            title: '',
            name: '',
            phone: '',
            email: '',
            comment: '',
            checked: true
        },
        errors: {
            name: {isError: false, message: ''},
            phone: {isError: false, message: ''},
            email: {isError: false, message: ''},
            checked: {isError: false, message: ''},
        },
    }),
    computed: {
        ...mapState('auth', [
            'user',
        ])
    },
    watch: {
        title: {
            handler(val) {
                this.form.title = val;
            },
            deep: true
        }
    },
    mounted() {
        if (this.title) {
            this.form.title = this.title;
        }

        this.$on('reset-form', () => {
            forEach(Object.getOwnPropertyNames(this.form), (property) => {
                this.form[property] = property !== 'checked' ? '' : true;
            });
        });

        this.$on('show-errors', (errors) => {
            this.createErrors(errors);
        });

        if (this.user) {
            this.form.name = this.user.name ?? '';
            this.form.email = this.user.email ?? '';
            this.form.phone = this.user.phone ?? '';
        }
    },
    methods: {
        submit() {
            if (!this.form.checked) {
                this.errors.checked.isError = true;

                this.errors.checked.message = this.$lang('feedback.form.checked');

                return;
            }

            this.$emit('send-form', this.form);
        }
    }
}
</script>
